import React, { Component } from 'react'
import { connect } from 'react-redux'
// import reduxStore from './redux-store'
import LoginCP from './components/login/LoginCP'
import PWResetCP from './components/login/PWResetCP'
import SiteFrameCP from './components/structure/SiteFrameCP'
import UserActions from './actions/user/user-actions'
import SystemActions from './actions/system/system-actions'
import GameActions from './actions/game/game-actions'

import './components/login/loading-cp.css'


// import { CONFIG } from './config.js';

class App extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    //console.log('Init App')
    var promises = []
    promises.push(this.props.getServerTimeOffset())
    promises.push(this.props.getConstants())
    promises.push(this.props.getUser())
    Promise.all(promises).then(() => this.props.setIsInit(true))
  }

  render() {
    //console.log(this.props)
    //console.log(localStorage)
    //const users = this.props.users.map((user, index) => <li key={index}>{user.id} {user.name}</li>);
    //const user = JSON.stringify(this.props.users)
    // if not User, show login
    // else show app
    var content = {}
    if (!this.props.isInit) {
      content = (this.renderLoading())
    } else if ("?pg=reset_pw_page" === window.location.search) {
      content = (<PWResetCP />)
    } else if (!this.props.user) {
      content = (<LoginCP />)
    } else {
      let gameId = (window.location.hash).substring(1)
      if (gameId) this.props.loadGame(gameId)
      content = (<SiteFrameCP />)
    }

    return content
  }

  renderLoading() {
    return (
      <div className='loading-contain'>
        <div>-{'{'}Ludodrome{'}'}-</div>
        <img src='/img/loading.gif' />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isInit: state.system.isInit,
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setIsInit: (isInit) => dispatch(SystemActions.setIsInit(isInit)),
    getServerTimeOffset: () => dispatch(SystemActions.getServerTimeOffset()),
    getConstants: () => dispatch(SystemActions.getConstants()),
    getUser: () => dispatch(UserActions.getUser()),
    logout: () => dispatch(UserActions.logout()),
    loadGame: (gameId) => dispatch(GameActions.loadGame(gameId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
